import { call, put, takeLatest } from 'redux-saga/effects';

import { psmAuditDigital, notification } from '../../actionTypes';
import dataProvider from '../../store/dataProvider';
import { getNotificationErrorMessage } from './helpers';

function* questions() {
  try {
    const { data } = yield call(dataProvider.getList, 'audit/question', {});
    const sections = ((data && data.sections) || [])
      .slice()
      .sort((a, b) => (a.order || 0) - (b.order || 0))
      .map(section => ({
        ...section,
        questions: ((section && section.questions) || []).slice().sort((a, b) => (a.order || 0) - (b.order || 0)),
      }));
    yield put({ type: psmAuditDigital.questions.end, payload: sections });
  } catch (e) {
    yield put({ type: psmAuditDigital.questions.error });
    yield put({
      type: notification.add,
      payload: { error: getNotificationErrorMessage(e, 'Failed to load audit questions') },
    });
  }
}

export default function* questionsSaga() {
  yield takeLatest(psmAuditDigital.questions.start, questions);
}
